'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconToggle = exports.IconToggleRoot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _mdc = require('@material/icon-toggle/dist/mdc.iconToggle');

var _Icon = require('../Icon');

var _Base = require('../Base');

var _MDCFoundation = require('../Base/MDCFoundation');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconToggleRoot = exports.IconToggleRoot = (0, _Base.simpleTag)({
  displayName: 'IconToggleRoot',
  tag: _Icon.Icon,
  classNames: 'mdc-icon-toggle',
  defaultProps: {
    role: 'button',
    tabIndex: '0'
  }
});

var IconToggle = exports.IconToggle = function (_withFoundation) {
  _inherits(IconToggle, _withFoundation);

  function IconToggle() {
    _classCallCheck(this, IconToggle);

    return _possibleConstructorReturn(this, (IconToggle.__proto__ || Object.getPrototypeOf(IconToggle)).apply(this, arguments));
  }

  _createClass(IconToggle, [{
    key: 'initialize',
    value: function initialize() {
      this.ripple_ = this.initRipple_();
      _get(IconToggle.prototype.__proto__ || Object.getPrototypeOf(IconToggle.prototype), 'initialize', this).call(this);
    }
  }, {
    key: 'syncWithProps',
    value: function syncWithProps(nextProps) {
      var _this2 = this;

      // checked
      (0, _MDCFoundation.syncFoundationProp)(nextProps.checked, this.on, function () {
        return _this2.on = nextProps.checked;
      });

      // disabled
      (0, _MDCFoundation.syncFoundationProp)(nextProps.disabled, this.disabled, function () {
        return _this2.disabled = nextProps.disabled;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          on = _props.on,
          off = _props.off,
          apiRef = _props.apiRef,
          rest = _objectWithoutProperties(_props, ['checked', 'on', 'off', 'apiRef']);

      var ariaPressed = checked !== undefined ? !!checked : false;
      var toggleOnJSON = JSON.stringify(on);
      var toggleOffJSON = JSON.stringify(off);

      return React.createElement(IconToggleRoot, Object.assign({}, rest, {
        className: this.classes,
        elementRef: this.foundationRefs.root_,
        'data-toggle-on': toggleOnJSON,
        'data-toggle-off': toggleOffJSON,
        'aria-pressed': ariaPressed
      }));
    }
  }]);

  return IconToggle;
}((0, _MDCFoundation.withFoundation)({
  constructor: _mdc.MDCIconToggle,
  adapter: {
    addClass: (0, _MDCFoundation.addClass)(),
    removeClass: (0, _MDCFoundation.removeClass)()
  }
}));

Object.defineProperty(IconToggle, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'IconToggle'
});
Object.defineProperty(IconToggle, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    onChange: _Base.noop,
    on: undefined,
    off: undefined,
    checked: undefined
  }
});
exports.default = IconToggle;



//////////////////
// WEBPACK FOOTER
// ./node_modules/rmwc/IconToggle/index.js
// module id = 62
// module chunks = 0